import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './RecipeList.css';
import Loading from '../../common/Loading';

function RecipeList() {
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://api.mutantbutton2.com/public/recipes')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch recipes');
        }
        return response.json();
      })
      .then(data => {
        setRecipes(data.recipes || []);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching recipes:', error);
        setError(error.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="recipe-list"><Loading /></div>;
  }

  if (error) {
    return <div className="recipe-list error">Error: {error}</div>;
  }

  return (
    <div className="recipe-list">
      <nav className="breadcrumb">
        <NavLink to="/">Home</NavLink>
        <span className="separator">></span>
        <span className="current">Recipes</span>
      </nav>
      
      <h1>All Recipes</h1>
      {recipes.length === 0 ? (
        <p className="no-recipes">No recipes available yet.</p>
      ) : (
        <div className="recipes-grid">
          {recipes.map((recipe, index) => {
            const formattedName = recipe.name
              .split('-')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
              .join(' ');
            
            return (
              <NavLink
                key={index}
                to={`/recipes/${recipe.name}`}
                className="recipe-card"
              >
                <div className="recipe-card-content">
                  <h3>{formattedName}</h3>
                  <span className="recipe-arrow">→</span>
                </div>
              </NavLink>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default RecipeList;
